import React, { useEffect } from "react";
import { Button, Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { showModal } from "../../../redux/actions/modal";
import CustomInputField from "../../CustomHTMLElements/CustomInputField";
import { formatMoney } from "../../../helpers/formatter";
import { appInsights } from "../../../config/appInsights";

const InvestmentDetails = ({
  principal_amount,
  currency,
  tenure,
  monthly_interest_repayment,
  effective_date,
  maturity_date,
  investment_product_name,
  interest_repayment_type,
  pub_date,
  outstanding_interest_amount,
  interest_amount,
  maturity_amount,
  outstanding_settlement,
  total_interest_paid,
  maturityInstruction,
  parent_investment_reference,
  child_investment_reference,
  rollOverType,
  is_roll_over,
  interest_rate,
  id,
  customerEmail,
}) => {
  const dispatch = useDispatch();

  console.log("id: ", id);

  useEffect(() => {
    appInsights.trackPageView({
      name: "Investment Details  - (InvestmentDetails.jsx)",
      isLoggedIn: true,
    });
  }, []);

  const handleViewCertificate = () => {
    dispatch(
      showModal({
        modalIdentifier: "viewinvestmentcertificate",
        dataRecord: {
          investmentId: id,
          currency: currency,
          customerEmail: customerEmail || "",
        },
      }),
    );
  };

  const handleSendCertificate = () => {
    dispatch(
      showModal({
        modalIdentifier: "viewinvestmentcertificate",
        dataRecord: {
          investmentId: id,
          currency: currency,
          customerEmail: customerEmail || "",
        },
      }),
    );
  };

  const handleMenuClick = (key) => {
    switch (key) {
      case "view":
        return handleViewCertificate();
      case "send":
        return handleSendCertificate();
      default:
        break;
    }
  };

  const menu = (
    <Menu
      onClick={({ key }) => handleMenuClick(key)}
      items={[
        {
          key: "view",
          label: "View Certificate",
          icon: <i className="fa fa-eye" />,
        },
        {
          key: "send",
          label: "Send Certificate",
          icon: <i className="fa fa-paper-plane" />,
        },
      ]}
    />
  );

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center my-4">
        <h6 className="page-subtitle mb-0">Investment Details</h6>
        <Dropdown overlay={menu} trigger={["click"]}>
          <Button type="primary" size="large">
            Take Action <DownOutlined />
          </Button>
        </Dropdown>
      </div>
      <form>
        <div className="row">
          <div className="col-md-6">
            <CustomInputField
              label="Investment Fund"
              defaultValue={investment_product_name}
              readOnly={true}
            ></CustomInputField>
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Investment Tenor"
              defaultValue={tenure}
              readOnly={true}
            />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Interest Rate"
              defaultValue={`${interest_rate}%`}
              readOnly={true}
            />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Repayment Type"
              defaultValue={interest_repayment_type}
              readOnly={true}
            />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Is Roll Over?"
              defaultValue={is_roll_over}
              readOnly={true}
            />
          </div>
          {is_roll_over && (
            <div className="col-md-6">
              <CustomInputField
                label="Roll Over Type"
                defaultValue={rollOverType}
                readOnly={true}
              />
            </div>
          )}

          <div className="col-md-12">
            <hr />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Date Invested"
              defaultValue={effective_date.substring(0, 10)}
              readOnly={true}
            />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Maturity Date"
              defaultValue={maturity_date.substring(0, 10)}
              readOnly={true}
            />
          </div>

          <div className="col-md-6">
            <CustomInputField
              label="Created Date"
              defaultValue={pub_date}
              readOnly={true}
            />
          </div>
          <div className="col-md-12">
            <hr />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Amount Invested"
              defaultValue={formatMoney(principal_amount, currency)}
              readOnly={true}
            ></CustomInputField>
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Total Repayment At Maturity"
              defaultValue={formatMoney(maturity_amount, currency)}
              readOnly={true}
            />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Monthly Yield"
              defaultValue={formatMoney(monthly_interest_repayment, currency)}
              readOnly={true}
            ></CustomInputField>
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Outstanding Interest Amount"
              defaultValue={formatMoney(outstanding_interest_amount, currency)}
              readOnly={true}
            ></CustomInputField>
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Total Interest At Maturity"
              defaultValue={formatMoney(interest_amount, currency)}
              readOnly={true}
            ></CustomInputField>
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Total Paid"
              defaultValue={total_interest_paid}
              readOnly={true}
            />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Outstanding Amount"
              defaultValue={formatMoney(outstanding_settlement, currency)}
              readOnly={true}
            />
          </div>
          <div className="col-md-12">
            <hr />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Maturity Instruction"
              defaultValue={maturityInstruction}
              readOnly={true}
            />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Parent Investment Reference"
              defaultValue={parent_investment_reference}
              readOnly={true}
            />
          </div>
          <div className="col-md-6">
            <CustomInputField
              label="Child Investment Reference"
              defaultValue={child_investment_reference}
              readOnly={true}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default InvestmentDetails;
